<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card class="mb-5">
        <vs-row vs-w="12" class="mb-5">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="goBack"
              color="danger"
              type="border"
              icon="keyboard_backspace"
              >Back</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="10"
            vs-sm="4"
            vs-xs="12"
          >
            <h3>View Elomark User Type</h3>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="1"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-button
              @click="editCompany"
              icon="edit"
              color="danger"
              type="border"
              >Edit</vs-button
            >
          </vs-col>
        </vs-row>
                <vs-divider class="m-5" />

        <div class="vx-row p-5" v-if="userDescription.usertype">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Type:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.usertype }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.usertype_description">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              User Type Description:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.usertype_description }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.is_client_usertype">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Client User Type:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.is_client_usertype }}
          </div>
        </div>
        <div class="vx-row p-5" v-if="userDescription.status">
          <div class="vx-col sm:w-1/5 w-full">
            <span>
              Status:
            </span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ userDescription.status }}
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import _ from "lodash";
import moduleUserTypesManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      userDescription: [],
      usertypeId: null,
    };
  },
  components: {
    "v-select": vSelect,
    moduleUserTypesManagement
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });   
    if (!moduleUserTypesManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypesManagement
      );
      moduleUserTypesManagement.isRegistered = true;
    }
  },
  mounted() {
        this.usertypeId = this.$route.params.usertypeId;
        this.fetchUserType()
  },
  methods: {
    fetchUserType() {
      this.$store
        .dispatch("usertypesManagement/fetchUserType", this.usertypeId)
        .then(res => {
          console.log(res)
          if(res){
              this.userDescription = res.data;
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.userDescription = true;
            return;
          }
          console.error(err);
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    editCompany() {
      this.$router.push({ path: `edit/${this.usertypeId}` });
    },
    convertTime(apiTime) {
      // date = Date.parse(apiTime)
      let date = new Date(apiTime);
      return date.toLocaleString();
    }
  }
};
</script>
<style scoped>
.con-vs-popup .vs-popup {
  width: 900px !important;
}

.item.expanded {
  color: black !important;
  background-color: none !important;
}

.vs-icon-bg.bg-small {
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid red;
  margin: 0px 20px;
  cursor: pointer;
}

.inputx {
  width: 50px;
}
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}
/* 
.item.expanded{
    background-color:white !important;
    color:black !important;
    cursor: pointer !important;
} */
</style>
